import { Link } from "react-router-dom";
import Logo from "./Logo";
import { JEREMY } from "@/lib/jeremy";

export default function Footer() {
  return (
    <footer className="bg-[#0B261E] text-[#F8FAFC] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-12 lg:grid-cols-3">
        <div className="space-y-4">
          <Logo variant="light" />
          <p className="text-sm text-[#F8FAFC]/70 max-w-xs">
            Solar guidance from someone who understands Virginia utilities, Virginia homes, and the questions local homeowners are asking.
          </p>
          <p className="text-xs text-[#FEF3C7]/70 max-w-xs pt-2 border-t border-white/10">
            Jeremy is an authorized representative of ION Solar. This website is Jeremy's independent local marketing and educational website and is not ION Solar's corporate website.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#FEF3C7] font-mono-metric mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/meet-jeremy" className="hover:text-[#D97706]">Meet Jeremy</Link></li>
            <li><Link to="/how-solar-works" className="hover:text-[#D97706]">How Solar Works</Link></li>
            <li><Link to="/why-solar-now" className="hover:text-[#D97706]">Why Solar Now</Link></li>
            <li><Link to="/homeowner-questions" className="hover:text-[#D97706]">Homeowner Questions</Link></li>
            <li><Link to="/why-ion" className="hover:text-[#D97706]">Why ION</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#FEF3C7] font-mono-metric mb-4">Virginia Service Areas</h4>
          <ul className="space-y-2 text-sm text-[#F8FAFC]/80">
            {JEREMY.serviceAreas.slice(0, 6).map((s) => <li key={s}>{s}</li>)}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-[#F8FAFC]/60 flex flex-col md:flex-row md:justify-between gap-2">
          <div>© {new Date().getFullYear()} Jeremy with ION Solar (independent local site). All rights reserved.</div>
          <div className="font-mono-metric">Eligibility and terms vary by property, utility territory, credit qualifications, and final agreement.</div>
        </div>
      </div>
    </footer>
  );
}
